import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';

import type {
    CheckEditingDisabledAction,
    EditorRestrictionsState,
    SetEditingDisabledAction,
    SuggestTariffAction,
} from './editorRestrictions.types';

const initialState: EditorRestrictionsState = {
    isChecked: false,
    editingRestricted: false,
};

const checkEditingDisabled = createAction<CheckEditingDisabledAction>('editorRestrictions/checkEditingDisabled');
const setEditingDisabled = createAction<SetEditingDisabledAction>('editorRestrictions/setEditingDisabled');
const suggestTariff = createAction<SuggestTariffAction>('editorRestrictions/suggestTariff');
const setEditingEnabled = createAction('editorRestrictions/setEditingEnabled');

export const editorRestrictionsReducer = createReducer(initialState, {
    [setEditingDisabled.toString()]: (state, action: PayloadAction<SetEditingDisabledAction>) => {
        state.isChecked = true;
        state.editingRestricted = action.payload.editingRestricted;
        state.quotaShortfall = action.payload.quotaShortfall;
    },
    [setEditingEnabled.toString()]: (state) => {
        state.isChecked = true;
        state.editingRestricted = false;
        state.quotaShortfall = undefined;
    },
});

export const EditorRestrictionsActions = {
    checkEditingDisabled,
    setEditingDisabled,
    setEditingEnabled,
    suggestTariff,
} as const;
